<template>
<div>
    <el-container style="height: 1500px; border: 1px solid #eee; margin:0 100px 0 100px">
        <el-aside width="200px" style="background-color: rgb(238, 241, 246); height: 700px">
            <h1 class="title">产品中心</h1>
            <hr class="fenge" size="5px" noshade=true/>
            <el-menu default-active="1" class="el-menu-vertical-demo" @select="handleSelect">
                <el-menu-item index="1">
                    <i class="el-icon-s-shop"></i>
                    <span slot="title">轴流风机</span>
                </el-menu-item>
                <el-menu-item index="2">
                    <i class="el-icon-s-shop"></i>
                    <span slot="title">离心风机</span>
                </el-menu-item>
                <el-menu-item index="3">
                    <i class="el-icon-s-shop"></i>
                    <span slot="title">防火阀</span>
                </el-menu-item>
                <el-menu-item index="4">
                    <i class="el-icon-s-shop"></i>
                    <span slot="title">配件</span>
                </el-menu-item>
            </el-menu>
        </el-aside>
    <el-container> 
    <el-main>
      <lunbo class="chanpinye" v-for="(item, i) in chanPinList" :key="i" :index="item.name" :ImgSrc="item.ImageSrc" :message="item.TitleText"></lunbo> 
    </el-main>
  </el-container>
</el-container>
</div> 
</template>


<script>
import lunbo from '../components/lunbo.vue';


  export default {
  components: { lunbo },
    data(){
      return{
        activeIndex: '1',
        chanPinList: [{ImageSrc: require('../assets/chanpin/3.jpg'), TitleText: '轴流式消防排烟风机'}, {ImageSrc: require('../assets/chanpin/5.jpg'), TitleText: '轴流式消防排烟风机'}, 
        {ImageSrc: require('../assets/chanpin/10.jpg'), TitleText: '轴流式消防排烟风机'},{ImageSrc: require('../assets/chanpin/8.jpg'), TitleText: '屋顶式消防排烟风机'}],
        navList:[
          [{ImageSrc: require('../assets/chanpin/3.jpg'), TitleText: '轴流式消防排烟风机'}, {ImageSrc: require('../assets/chanpin/5.jpg'), TitleText: '轴流式消防排烟风机'}, 
          {ImageSrc: require('../assets/chanpin/10.jpg'), TitleText: '轴流式消防排烟风机'},{ImageSrc: require('../assets/chanpin/8.jpg'), TitleText: '屋顶式消防排烟风机'}],
          [{ImageSrc: require('../assets/chanpin/2.jpg'), TitleText: '离心风机'}, {ImageSrc: require('../assets/chanpin/7.jpg'), TitleText: '离心风机'},
          {ImageSrc: require('../assets/chanpin/4.jpg'), TitleText: '柜式离心风机'}, {ImageSrc: require('../assets/chanpin/6.jpg'), TitleText: '离心式消防排烟风机'}, {ImageSrc: require('../assets/chanpin/1.jpg'), TitleText: 'DBF离心风机'}, ],
          [{ImageSrc: require('../assets/chanpin/11.jpg'), TitleText: '防火阀'}, {ImageSrc: require('../assets/chanpin/12.jpg'), TitleText: '排烟防火阀'},],
          [{ImageSrc: '231231', TitleText: '消声器'}, {ImageSrc: require('../assets/chanpin/13.jpg'), TitleText: '铝合金风口'},{ImageSrc: require('../assets/chanpin/14.jpg'), TitleText: '铝合金风口'}]
      ],
      }
    },    
    methods: {
      handleSelect(key) {
        return this.chanPinList = this.navList[key-1]
      },
    }
  }
</script>

<style scoped>

.fenge {
    width: 95px;
    margin-top: 0;
    margin-left: 15px;
    background-color: rgb(24, 140, 179);
    border: rgb(24, 140, 179);
    box-shadow: 0 0 0 0;
}

.title {
    font-size: 200%;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 15px;
}

.chanpinye {
  display: inline-block;
  width: 480px;
  height: 400px;
}
</style>
